import { UseQueryOptions, useQuery } from 'react-query';
import { RemoteAiRepo } from './AiRepo';

const remoteAiRepo = new RemoteAiRepo();
const keys = ['ai', 'trialResult'];

const fetchTrialResult = async () => {
  const { data } = await remoteAiRepo.trialResult();
  return data;
};

export function useTrialResult(options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>) {
  return useQuery(keys, fetchTrialResult, options as any);
}
